import numeral from "numeral";
import PencilIcon from "../../../components/icon/pencilIcon";
import { cn } from "../../../utils/useFunctions";
import { INSURANCE_POLICY_STATUS } from "../../balance/functions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_MEDIUM_13,
  STYLE_PDF_TEXT_SEMIBOLD_BLUE_14,
} from "../styles/pdf.style";

export const changeDateFormat = (dateTimeBefore) => {
  const fullDate = dateTimeBefore.split("-");
  return `${fullDate[2]}/${fullDate[1]}/${Number(fullDate[0] || 0) + 543}`;
};

function ExpenseInsuranceDetailPDF({ page, data }) {
  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="ประกันของคุณ"
        icon="/images/insuranceClibboard.png"
        classNameIcon="w-[35px] h-[24px]"
        classNameTitle="text-[20px] font-bold"
      />

      <PdfCard
        className={"flex flex-col space-y-3"}
        title={"ประกันชีวิต"}
        classNameTitle={"text-[12px] font-[500]"}
      >
        <PdfCardWhite className={cn("px-3")}>
          <div className="flex flex-row w-full space-x-[10px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                ชื่อบริษัทประกัน{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${data?.title ? data?.title : "-"}`}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                กรมธรรม์ประเภท{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${
                  data?.insurance_policy_type
                    ? data?.insurance_policy_type
                    : "-"
                }`}
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                กรมธรรม์เลขที่{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${
                  data?.insurance_policy_number
                    ? data?.insurance_policy_number
                    : "-"
                }`}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                ชื่อกรมธรรม์{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${
                  data?.insurance_policy_name
                    ? data?.insurance_policy_name
                    : "-"
                }`}
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                วันที่ของกรมธรรม์ ประกันภัย{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${
                  data?.insurance_policy_date
                    ? changeDateFormat(data?.insurance_policy_date)
                    : "-"
                }`}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                วันทำสัญญา ประกันภัย{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${
                  data?.date_insurance_policy_makecompact
                    ? changeDateFormat(data?.date_insurance_policy_makecompact)
                    : "-"
                }`}
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                วันครบกำหนด สัญญาประกันภัย{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${
                  data?.date_insurance_policy_finishcompact
                    ? changeDateFormat(
                        data?.date_insurance_policy_finishcompact
                      )
                    : "-"
                }`}
              </div>
            </div>
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                {" "}
                สถานะกรมธรรม์{" "}
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >
                {`${
                  INSURANCE_POLICY_STATUS?.find(
                    (item) => item?.value === data?.insurance_policy_status
                  )?.label || "-"
                }`}
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                ค่าเบี้ย (ต่อปี)
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >{` ${data?.allowance_peryear?numeral(data?.allowance_peryear).format("0,0"):'-'} บาท`}</div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                ทุนประกัน
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >{` ${data?.insurance_fund?numeral(data?.insurance_fund).format("0,0"):'-'} บาท`}</div>
            </div>
          </div>

          <div className="flex flex-row w-full space-x-[10px] mt-[5px] py-[2.5px]">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center": true,
                })}
              >
                มูลค่าเวนคืนกรมธรรม์
              </div>
              <div
                className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                  "font-[400] flex items-center text-center": true,
                })}
              >{` ${data?.insurance_policy_cash_surrender?numeral(data?.insurance_policy_cash_surrender).format(
                "0,0"
              ):'-'} บาท`}</div>
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <PencilIcon />
                <div className="ml-[5px]">กรอกรายละเอียดเพิ่มเติม</div>
              </div>
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_13, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">รายการ</div>
              </div>
            </div>
          </div>

          <div className="py-[10px]">
            <PdfLine className={"mt-0 mb-0"} />
          </div>

          <div className="flex flex-row w-full py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ชีวิตตามแบบประกันภัยข้างต้น</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.life_insurance ? numeral(data?.more_details?.life_insurance).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">ชีวิตสำหรับเบี้ยประกันภัยลงทุน</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.life_allowance ? numeral(data?.more_details?.life_allowance).format("0,0"):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ยกเว้นเบี้ยกรมธรรม์ประกันภัยหลัก (WP)
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.except_allowance_wp?numeral(data?.more_details?.except_allowance_wp).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">
                  ยกเว้นเบี้ยกรมธรรม์ประกันภัยหลัก (PB)
                </div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.except_allowance_pb?numeral(data?.more_details?.except_allowance_pb).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>

          <div className="flex flex-row w-full mt-[10px] py-[2.5px] ">
            <div className="flex justify-between w-full">
              <div
                className={cn(STYLE_PDF_TEXT_MEDIUM_11, {
                  " flex items-center text-center font-[600] ": true,
                })}
              >
                <div className="ml-[5px]">สัญญาเพิ่มเติมกรณีทุพพลภาพ (TPD)</div>
              </div>
            </div>
            <div
              className={cn(STYLE_PDF_TEXT_SEMIBOLD_BLUE_14, {
                "font-[400] flex items-center text-center": true,
              })}
            >
              {`${data?.more_details?.contract_tpd?numeral(data?.more_details?.contract_tpd).format(
                "0,0"
              ):'-'}`}
            </div>
          </div>
        </PdfCardWhite>
      </PdfCard>
      <PdfFooter page={page} />
    </div>
  );
}

export default ExpenseInsuranceDetailPDF;
